import { type ButtonHTMLAttributes } from 'react';

type TabOption = { key: string; label: string };

interface AppTabProps {
  tabs: TabOption[];
  active: string;
  onChange: (key: string) => void;
  className?: string;
}

export default function AppTab({
  tabs,
  active,
  onChange,
  className = '',
}: AppTabProps) {
  return (
    <div className={`flex border-b border-line-normal ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onChange(tab.key)}
          className={`flex-1 py-4 text-label1 font-medium text-center transition-colors relative cursor-pointer select-none whitespace-nowrap ${
            active === tab.key
              ? 'text-label-normal'
              : 'text-label-alt hover:text-label-neutral'
          }`}
        >
          {tab.label}
          {active === tab.key && (
            <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-primary-normal rounded-full"></span>
          )}
        </button>
      ))}
    </div>
  );
}